import { render, staticRenderFns } from "./HomeThird.vue?vue&type=template&id=6bbb53a7&scoped=true&"
import script from "./HomeThird.vue?vue&type=script&lang=js&"
export * from "./HomeThird.vue?vue&type=script&lang=js&"
import style0 from "./HomeThird.vue?vue&type=style&index=0&id=6bbb53a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb53a7",
  null
  
)

export default component.exports